import React, { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AppSpinner from './AppSpinner';

import {
	lazyIndexRoute,
	lazyQuestionListPage,
	lazyQuestionAskPage,
	lazyQuestionEditPage,
	lazyQuestionViewPage,
	lazyTopicListPage,
	lazyTopicCreatePage,
	lazyTopicEditPage,
	lazyQuestionListByTopicPage,
	lazyExpertListPage,
	lazyQuestionListMacroPage,
	lazyActionPage,
	lazyAdminPage,
} from './lazy-components';

export const routes = [
	{ path: '/questions-bootstrap', component: lazyQuestionListPage, header: true, exact: true },
	{ path: '/questions/ask', component: lazyQuestionAskPage },
	{ path: '/questions/edit/:id', component: lazyQuestionEditPage },
	{ path: '/questions/:id', component: lazyQuestionViewPage, header: true },
	{ path: '/questions/:id/answer/:answerId', component: lazyQuestionViewPage, header: true },
	{
		path: '/questions/:id/answer/:answerId/comment/:commentId',
		component: lazyQuestionViewPage,
		header: true,
	},
	{ path: '/questions/:id/comment/:commentId', component: lazyQuestionViewPage, header: true },
	{ path: '/questions', component: lazyQuestionListPage, header: true, exact: true },
	{ path: '/topics', component: lazyTopicListPage, exact: true, header: true },
	{ path: '/topics/create', component: lazyTopicCreatePage },
	{ path: '/topics/edit/:id', component: lazyTopicEditPage },
	{ path: '/topics/:name', component: lazyQuestionListByTopicPage, header: true },
	{ path: '/experts', component: lazyExpertListPage, header: true },
	{ path: '/space', component: lazyQuestionListPage, header: true },
	{ path: '/action/:action/:type/:id?', component: lazyActionPage },
	{ path: '**', component: () => () => <Redirect to="/questions-bootstrap" /> },
];

export default (
	<Suspense fallback={<AppSpinner />}>
		<Switch>
			<Route path="/confluence-questions-configuration" component={lazyAdminPage()} />
			<Route path="/questions-macro" component={lazyQuestionListMacroPage()} />
			<Route component={lazyIndexRoute()} />
		</Switch>
	</Suspense>
);
